__turbopack_context__.v({
  "actionBtn": "countDownCardBlock-styles-module-scss-module__UXW-Xa__actionBtn",
  "actionBtnSidebar": "countDownCardBlock-styles-module-scss-module__UXW-Xa__actionBtnSidebar",
  "content": "countDownCardBlock-styles-module-scss-module__UXW-Xa__content",
  "contentMain": "countDownCardBlock-styles-module-scss-module__UXW-Xa__contentMain",
  "countdown": "countDownCardBlock-styles-module-scss-module__UXW-Xa__countdown",
  "countdownWrap": "countDownCardBlock-styles-module-scss-module__UXW-Xa__countdownWrap",
  "counterSection": "countDownCardBlock-styles-module-scss-module__UXW-Xa__counterSection",
  "description": "countDownCardBlock-styles-module-scss-module__UXW-Xa__description",
  "row": "countDownCardBlock-styles-module-scss-module__UXW-Xa__row",
  "stack": "countDownCardBlock-styles-module-scss-module__UXW-Xa__stack",
  "wrapper": "countDownCardBlock-styles-module-scss-module__UXW-Xa__wrapper",
  "wrapperSidebar": "countDownCardBlock-styles-module-scss-module__UXW-Xa__wrapperSidebar",
});
